import React from 'react';
import { Button } from '@material-ui/core';
import SpeedIcon from '@material-ui/icons/Speed';
import { usePermissions, useTranslate } from 'react-admin';
import { UserRole } from '../../../entities';

interface BenchmarkButtonProps {
  onStartBenchmark: () => void;
  isRunning: boolean;
}

export const BenchmarkButton: React.FC<BenchmarkButtonProps> = ({
  onStartBenchmark,
  isRunning,
}) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const isAdmin = permissions && permissions.role === UserRole.admin;

  if (!isAdmin) return null;

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onStartBenchmark}
      disabled={isRunning}
      startIcon={<SpeedIcon />}
      fullWidth
      style={{ marginTop: 15 }}
    >
      {isRunning ? translate('osfc.storage_ui.benchmark.running') : translate('osfc.storage_ui.benchmark.run')}
    </Button>
  );
};
